"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
var Head_1 = require("./Head");
Object.defineProperty(exports, "Head", { enumerable: true, get: function () { return Head_1.Head; } });
